// JSX
import { Fragment } from "react";
import "./Banner.css"

export const Banner = () => {
  return (

    <>

      <header className="banner">
        <img src="imgs/banner.png" alt="O banner principal da página do Organo" />

      </header>
      <teste />

    </>


  );
}
